module.exports = __webpack_public_path__ + "media/home/BrandsIcon-ce01435f.png";